import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { getKeycloak } from "./auth/keycloak";

export function initI18n() {
  if (i18n.isInitialized) return Promise.resolve();

  return i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      defaultNS: "translation",
      ns: ["translation"],
      supportedLngs: ["en-US", "bg-BG", "ru-RU", "ro-RO", "es-ES"],
      fallbackLng: "en-US",
      debug: true,
      backend: {
        loadPath: `${process.env.REACT_APP_BASE_URL_TRANSLATIONS}/locales/{{lng}}/{{ns}}.json`,
        customHeaders: () => ({
          Authorization: `Bearer ${getKeycloak()?.token ?? ""}`,
        }),
      },
      react: {
        useSuspense: false,
      },
    });
}

export default i18n;
